import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onTriggerClick", "expanded", "rowId", "enableTriggerVisibility"];
export var useTableControllerCell = function useTableControllerCell(_ref) {
  var onTriggerClick = _ref.onTriggerClick,
      expanded = _ref.expanded,
      rowId = _ref.rowId,
      enableTriggerVisibility = _ref.enableTriggerVisibility,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return {
    rootProps: restProps,
    triggerProps: {
      light: true,
      marginRight: 2.5,
      onClick: onTriggerClick,
      visible: enableTriggerVisibility !== false,
      'data-rowid': rowId
    },
    triggerIconProps: {
      small: true,
      expanded: expanded
    }
  };
};